import { render, staticRenderFns } from "./multi-toggle.vue?vue&type=template&id=36f16d71&scoped=true"
import script from "./multi-toggle.vue?vue&type=script&lang=js"
export * from "./multi-toggle.vue?vue&type=script&lang=js"
import style0 from "./multi-toggle.vue?vue&type=style&index=0&id=36f16d71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f16d71",
  null
  
)

export default component.exports